<template>
  <div class="fixed z-3000 w-full">
    <el-menu
      :default-active="activeIndex2"
      class="ocr-header el-menu-demo pl-0 w-full relative"
      id="navbar"
      mode="horizontal"
      background-color="#FFFFFF"
      text-color="#000"
    >
      <el-menu-item index="1" class="float-left home-menu-item">
        <router-link :to="{ name: 'home'}" class="home text-black">
          Yomokka
        </router-link>
        <div class="triangle-title-bg"></div>
      </el-menu-item>
      <el-menu-item index="3" class="float-left breadcrumb-menu-item ocr-display-tablet">
        <Breadcrumb v-if="getDevice == 'desktop'" :user="authUser"/>
      </el-menu-item>
      <!--  Change theme -->
      <el-submenu index="3" class="theme-menu-item">
        <template slot="title">
          <div class="flex justify-center items-center h-full setting-icon">
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.4371 14.6253L19.8154 13.2388C19.8921 12.7684 19.9318 12.2881 19.9318 11.8078C19.9318 11.3275 19.8921 10.8472 19.8154 10.3768L21.4371 8.99031C21.5594 8.88559 21.6469 8.74613 21.688 8.59046C21.7292 8.43478 21.7219 8.27028 21.6673 8.11881L21.645 8.05444C21.1986 6.80669 20.5301 5.65 19.6718 4.64027L19.6272 4.58828C19.5231 4.46585 19.3843 4.37785 19.2292 4.33586C19.0741 4.29388 18.9099 4.29988 18.7582 4.35308L16.7454 5.06859C16.0026 4.45954 15.1732 3.97923 14.277 3.64251L13.8883 1.53806C13.8589 1.37971 13.7821 1.23403 13.668 1.12038C13.5539 1.00673 13.4079 0.93048 13.2495 0.901769L13.1826 0.88939C11.8927 0.656662 10.536 0.656662 9.24607 0.88939L9.17922 0.901769C9.02076 0.93048 8.87479 1.00673 8.76069 1.12038C8.6466 1.23403 8.56979 1.37971 8.54046 1.53806L8.14928 3.65242C7.26018 3.9892 6.43221 4.46926 5.69821 5.07354L3.6705 4.35308C3.5189 4.29945 3.35456 4.29324 3.19934 4.33525C3.04412 4.37726 2.90535 4.46551 2.80149 4.58828L2.75692 4.64027C1.89965 5.65072 1.23125 6.80721 0.783684 8.05444L0.761401 8.11881C0.649989 8.42829 0.741595 8.77491 0.991653 8.99031L2.63313 10.3916C2.55638 10.8571 2.51924 11.3324 2.51924 11.8053C2.51924 12.2807 2.55638 12.756 2.63313 13.219L0.991653 14.6203C0.869337 14.7251 0.781793 14.8645 0.740664 15.0202C0.699534 15.1759 0.706767 15.3404 0.761401 15.4918L0.783684 15.5562C1.23181 16.804 1.89533 17.9553 2.75692 18.9704L2.80149 19.0224C2.9056 19.1448 3.04437 19.2328 3.19951 19.2748C3.35464 19.3168 3.51885 19.3108 3.6705 19.2576L5.69821 18.5371C6.436 19.1437 7.26045 19.624 8.14928 19.9582L8.54046 22.0726C8.56979 22.2309 8.6466 22.3766 8.76069 22.4903C8.87479 22.6039 9.02076 22.6802 9.17922 22.7089L9.24607 22.7213C10.5478 22.9552 11.8809 22.9552 13.1826 22.7213L13.2495 22.7089C13.4079 22.6802 13.5539 22.6039 13.668 22.4903C13.7821 22.3766 13.8589 22.2309 13.8883 22.0726L14.277 19.9681C15.1728 19.6323 16.0069 19.1504 16.7454 18.5421L18.7582 19.2576C18.9098 19.3112 19.0741 19.3174 19.2294 19.2754C19.3846 19.2334 19.5234 19.1451 19.6272 19.0224L19.6718 18.9704C20.5334 17.9528 21.1969 16.804 21.645 15.5562L21.6673 15.4918C21.7787 15.1873 21.6871 14.8407 21.4371 14.6253ZM18.0575 10.6689C18.1194 11.0428 18.1516 11.4265 18.1516 11.8103C18.1516 12.194 18.1194 12.5778 18.0575 12.9516L17.8941 13.9444L19.7436 15.5265C19.4632 16.1724 19.1093 16.7839 18.6889 17.3487L16.3913 16.5342L15.6139 17.1729C15.0222 17.6582 14.3636 18.0395 13.6506 18.3069L12.7073 18.6609L12.2641 21.0625C11.5649 21.1417 10.8589 21.1417 10.1597 21.0625L9.71648 18.6559L8.78061 18.297C8.075 18.0296 7.41891 17.6483 6.83214 17.1655L6.05473 16.5243L3.7423 17.3462C3.32141 16.7793 2.96984 16.1677 2.6876 15.524L4.55685 13.9271L4.39592 12.9368C4.3365 12.5679 4.30431 12.1866 4.30431 11.8103C4.30431 11.4315 4.33402 11.0527 4.39592 10.6838L4.55685 9.69344L2.6876 8.09653C2.96737 7.45034 3.32141 6.84128 3.7423 6.27432L6.05473 7.0963L6.83214 6.45506C7.41891 5.97227 8.075 5.59099 8.78061 5.3236L9.71895 4.96956L10.1621 2.56305C10.8578 2.48382 11.5684 2.48382 12.2666 2.56305L12.7098 4.96461L13.653 5.31865C14.3636 5.58604 15.0247 5.96732 15.6164 6.45258L16.3938 7.09134L18.6914 6.2768C19.1123 6.84376 19.4638 7.45529 19.7461 8.09901L17.8966 9.68106L18.0575 10.6689ZM11.2168 7.20523C8.81032 7.20523 6.85937 9.15619 6.85937 11.5627C6.85937 13.9692 8.81032 15.9202 11.2168 15.9202C13.6233 15.9202 15.5743 13.9692 15.5743 11.5627C15.5743 9.15619 13.6233 7.20523 11.2168 7.20523ZM13.1777 13.5236C12.9205 13.7815 12.6149 13.986 12.2783 14.1254C11.9418 14.2647 11.5811 14.3362 11.2168 14.3356C10.4766 14.3356 9.78085 14.046 9.25597 13.5236C8.99805 13.2664 8.79352 12.9607 8.65416 12.6242C8.51479 12.2877 8.44333 11.9269 8.4439 11.5627C8.4439 10.8224 8.73357 10.1267 9.25597 9.60184C9.78085 9.07696 10.4766 8.78976 11.2168 8.78976C11.9571 8.78976 12.6528 9.07696 13.1777 9.60184C13.4356 9.85902 13.6401 10.1647 13.7795 10.5012C13.9189 10.8377 13.9903 11.1985 13.9898 11.5627C13.9898 12.303 13.7001 12.9987 13.1777 13.5236Z" fill="#7B7B7B"/>
            </svg>
          </div>
        </template>
<!--        <el-menu-item index="3-1">ヘルプ</el-menu-item>-->
        <el-menu-item-group title="テーマ色変更">
          <el-menu-item v-for="(item, index) in themeList" :key="`theme-${index}`" index="3-1" @click="selectTheme(item)">
            <div class="theme-list-item">
              <div :style="{'background-color': item.code}" class="theme-item-circle"></div>
              <div class="theme-item-text">{{ item.text }}</div>
            </div>
          </el-menu-item>

        </el-menu-item-group>
<!--        <el-menu-item index="3-3">ライセンス情報</el-menu-item>-->
<!--        <el-menu-item index="3-4">アップデート情報</el-menu-item>-->
      </el-submenu>
      <el-submenu index="2" class="user-menu-item">
        <template slot="title">
          <div class="flex justify-center items-center">
            <img
              v-if="authUser && authUser.avatar"
              class="items-center rounded-full w-10 h-10"
              :src="authUser.avatar"
              alt=""
            />
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.9923 32C24.7617 32 32 24.7582 32 16C32 7.24178 24.7463 0 15.9768 0C7.22281 0 0 7.24178 0 16C0 24.7582 7.23828 32 15.9923 32ZM15.9923 21.354C11.6307 21.354 8.2436 22.9168 6.60416 24.7118C4.50073 22.4371 3.21701 19.3733 3.21701 16C3.21701 8.89749 8.89319 3.20309 15.9768 3.20309C23.0759 3.20309 28.783 8.89749 28.7985 16C28.7985 19.3733 27.5147 22.4371 25.3958 24.7273C23.7564 22.9168 20.3693 21.354 15.9923 21.354ZM15.9923 18.8162C18.9928 18.8472 21.3282 16.2785 21.3282 12.9671C21.3282 9.84139 18.9773 7.22631 15.9923 7.22631C13.0227 7.22631 10.6564 9.84139 10.6718 12.9671C10.6873 16.2785 13.0072 18.8008 15.9923 18.8162Z" fill="#7B7B7B"/>
            </svg>
            <p class="ml-2 ocr-display-tablet">{{  (authUser.role && !authUser.is_superuser) ? authUser.org_name : authUser.full_name }}</p>
          </div>
        </template>
        <el-menu-item
          v-if="authUser && !!authUser.role && !authUser.is_superuser"
          index="2-2"
          @click="goToAdmin"
          >管理</el-menu-item
        >
<!--        <el-menu-item-->
<!--            v-if="authUser && !!authUser.role && !authUser.is_superuser"-->
<!--            index="2-4"-->
<!--            @click="goToStatistical"-->
<!--        >処理の統計</el-menu-item-->
<!--        >-->
        <el-menu-item index="2-1" @click="goToUserProfile" style="color: #000;"  v-if="authUser && !authUser.is_superuser">
          ユーザープロファイル
        </el-menu-item>
        <el-menu-item index="2-4" v-if="authUser && authUser.is_superuser" @click="goToAdminOrganization">グループ一覧
        </el-menu-item>
        <el-menu-item index="2-3" @click="logout">ログアウト</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item
        index="3"
        class="el-submenu flex justify-center items-center"
      >
        <img src="@/assets/setting.png" alt="" />
      </el-menu-item>
      <el-menu-item
        index="4"
        class="el-submenu flex justify-center items-center"
      >
        <div class="search-box1">
          <button class="btn-search">
            <img src="@/assets/search.png" alt="" />
          </button>
          <input
            type="text"
            class="input-search"
            placeholder="検索"
          />
        </div>
      </el-menu-item> -->
    </el-menu>
  </div>
</template>

<script>
import Breadcrumb from "@/pages/layouts/breadcrumb";
import { mapActions, mapState, mapGetters } from "vuex";
import { THEME_LIST } from "@/constants/setting.js";
import { ROLE_ADMIN } from "@/constants/organization";

export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      themeList: THEME_LIST,
      roleAdmin: ROLE_ADMIN
    };
  },
  props: {
    authUser: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      setting: state => state.user.setting,
    }),
    ...mapGetters("device", ['getDevice']),
  },
  async created() {
  },
  async mounted() {
    // Set cached theme
    this.setThemeClass();

    // Load and set user theme
    await this.getTheme();
    this.setThemeClass();
  },

  methods: {
    ...mapActions("auth", ["logOut"]),
    ...mapActions(['loading']),
    ...mapActions("user", ["getTheme", "updateTheme"]),
    ...mapActions("template", ["logoutTemplate"]),

    logout: function() {
      this.loading(true);
      setTimeout(() => {
        this.logOut();
        this.logoutTemplate();
        this.loading(false);
      }, 1000);
    },

    goToUserProfile: function() {
      this.$router.push({
        name: "user_profile",
      });
    },

    goToStatistical() {
      this.$router.push({
        name: "admin_statistical",
      });
    },

    goToAdmin: function() {
      this.$router.push({
        name: "admin_user",
      });
    },
    async selectTheme (item) {
      await this.updateTheme(item.code);
      this.setThemeClass();
    },
    setThemeClass: function () {
      document.body.setAttribute('ocr-theme', `${this.setting.theme.name}`);
    },

    goToAdminOrganization: function () {
      this.$router.push({
        name: "admin_organizations",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.z-3000 {
  z-index: 3000;
}
.ocr-header {
  display: flex;
  border-bottom: solid 1px #7B7B7B;
}

.user-menu-item {
  margin-left: auto;
  order: 1;
}
.theme-menu-item {
  order: 2;
}

.bg-header {
  background: #0f172a;
}
/deep/.el-submenu {
  float: right !important;
}

/deep/.el-icon-arrow-down {
  display: none;
}
/deep/.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0 !important;
  color: #000;
}
/deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
  display: flex;
}
/deep/.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #000;
  border-bottom: 0 !important;
}
.el-submenu.is-active .el-submenu__title {
  border-bottom: 0;
}
.el-menu-item {
  border: none;
}

.home-menu-item {
  padding-left: 0;
  padding-right: 0;
}

.home {
  font-weight: bold;
  font-size: 18px;
  float: left;
  padding-left: 30px;
  padding-right: 30px;
}

.triangle-title-bg {
  width: 0;
  height: 0;
  border-left: 30px solid #FDB92C;
  border-top: 30px solid transparent;
  border-right: 30px solid transparent;
  border-bottom: 30px solid transparent;
  float: left;
}

.breadcrumb-menu-item {
  padding-left: 0;
  padding-right: 0;
}

.home-menu-item:hover, .breadcrumb-menu-item:hover {
  background: none !important;
}

.search-box {
  width: fit-content;
  height: fit-content;
  position: relative;
}
.input-search {
  height: 50px;
  width: 50px;
  border-style: none;
  padding: 10px;
  font-size: 18px;
  letter-spacing: 2px;
  outline: none;
  border-radius: 25px;
  transition: all 0.5s ease-in-out;
  background-color: inherit;
  padding-right: 40px;
  color: #fff;
}
.input-search::placeholder {
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  letter-spacing: 2px;
  font-weight: 100;
}
.btn-search {
  border-style: none;
  font-size: 20px;
  font-weight: bold;
  outline: none;
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 40px;
  color: #ffffff;
  background-color: transparent;
  pointer-events: painted;
}
.btn-search:focus ~ .input-search {
  width: 300px;
  border-radius: 0px;
  background-color: transparent;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  transition: all 500ms cubic-bezier(0, 0.11, 0.35, 2);
}
.input-search:focus {
  width: 300px;
  border-radius: 0px;
  background-color: transparent;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  transition: all 500ms cubic-bezier(0, 0.11, 0.35, 2);
}

.theme-list-item {
  display: flex;
  padding-left: 40px;
  align-items: center;
}

.setting-icon i {
  color: #000000;
}

.theme-item-circle {
  width: 15px;
  height: 15px;
  margin-right: 10px;
  border-radius: 50%;
}

.el-menu .el-menu-item-group /deep/.el-menu-item-group__title {
  padding: 0 10px !important;
  color: #000000 !important;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
}

ul.el-menu.el-menu--popup > .el-menu-item {
  border-bottom: 1px solid #E7E7E7;
}

ul.el-menu.el-menu--popup > .el-menu-item:last-child {
  border-bottom: none;
}

.el-menu.el-menu--popup,
.el-menu.el-menu--popup .el-menu-item,
.el-menu--popup .el-menu-item-group
{
  background-color: #F4F4F4 !important;
}

@media screen and (max-width: 767px) {
  /deep/ .el-submenu__title {
    padding: 0 10px;
  }
  /deep/ .el-menu--horizontal > .el-menu-item {
    height: 48px;
    line-height: 48px;
  }
  .triangle-title-bg {
    border-left-width: 16px !important;
    border-top-width: 24px;
    border-right-width: 24px;
    border-bottom-width: 24px;
  }

  /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 48px;
    line-height: 48px;
  }
  .theme-menu-item {
    order: 1;
    margin-left: auto;
  }
  .user-menu-item {
    order: 2;
    margin-left: unset;
  }
}
</style>
